import { createContext, useContext, useState } from 'react';
import {
  APPLICATION_FORM_STAGES,
  SELECT_FIELD_DEFAULT_VALUE,
} from '../constants/settings';
import { SelectData } from '../types/common';
import { Language } from '../types/languages';

// datatype of the context declared here
interface IApplicationContext {
  currentFormStage: string;
  username: string;
  selectedCountryCode: string;
  selectedCountry: SelectData;
  selectedLanguages: Array<Language>;
  selectedServices: Array<SelectData>;
  setCurrentFormStage: React.Dispatch<React.SetStateAction<string>>;
  setUsername: React.Dispatch<React.SetStateAction<string>>;
  setSelectedCountryCode: React.Dispatch<React.SetStateAction<string>>;
  setSelectedCountry: React.Dispatch<React.SetStateAction<SelectData>>;
  setSelectedLanguages: React.Dispatch<React.SetStateAction<Array<Language>>>;
  setSelectedServices: React.Dispatch<React.SetStateAction<Array<SelectData>>>;
}

// creating the context here
const ApplicationContext = createContext<IApplicationContext | null>(null);

const ApplicationProvider = ({ children }: { children: React.ReactNode }) => {
  // integration of react hooks here
  const [currentFormStage, setCurrentFormStage] = useState<string>(
    APPLICATION_FORM_STAGES[0]
  );
  const [username, setUsername] = useState<string>('');
  const [selectedCountryCode, setSelectedCountryCode] = useState<string>('');

  const [selectedCountry, setSelectedCountry] = useState<SelectData>(
    SELECT_FIELD_DEFAULT_VALUE
  );

  const [selectedLanguages, setSelectedLanguages] = useState<Array<Language>>(
    []
  );
  const [selectedServices, setSelectedServices] = useState<Array<SelectData>>(
    []
  );

  // rendering the context provider here
  return (
    <ApplicationContext.Provider
      value={{
        currentFormStage,
        username,
        selectedCountryCode,
        selectedCountry,
        selectedLanguages,
        selectedServices,
        setCurrentFormStage,
        setUsername,
        setSelectedCountryCode,
        setSelectedCountry,
        setSelectedLanguages,
        setSelectedServices,
      }}
    >
      {children}
    </ApplicationContext.Provider>
  );
};

export default ApplicationProvider;

// creating custom hook to access the application context here
export const useApplicationContext = () => {
  const context = useContext(ApplicationContext);

  if (!context) {
    throw new Error(
      'useApplicationContext must be within ApplicationProvider!'
    );
  }

  return context;
};
